module.exports = __webpack_public_path__ + "img/tuto2.3e25e006.png";